// extracted by mini-css-extract-plugin
module.exports = {"clearFiltersButton":"ClearFilters_clearFiltersButton__C6vKu"};